import * as React from "react"
import List from "@mui/material/List"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import Collapse from "@mui/material/Collapse"
import Typography from "@mui/material/Typography"
import ExpandLess from "@mui/icons-material/ExpandLess"
import ExpandMore from "@mui/icons-material/ExpandMore"
import { styled } from "@mui/material/styles"
import Box from "@mui/material/Box"
import { SidebarContext } from "./Sidebar"

const Submenu = ({
    children,
    title = "",
    icon,
    borderRadius = "8px",
    textFontSize = "14px",
    disabled = false,
    defaultOpen = false,
    isSidebarCollapsed,
}) => {
    const customizer = React.useContext(SidebarContext)
    const [open, setOpen] = React.useState(defaultOpen)

    const handleClick = () => {
        setOpen(!open)
    }

    const ListItemStyled = styled(ListItemButton)(() => ({
        whiteSpace: "nowrap",
        marginBottom: "2px",
        padding: "10px 12px",
        borderRadius: borderRadius,

        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? "0.6" : "1",
    }))

    const ListIConStyled = styled(ListItemIcon)(() => ({
        display: "flex",
        gap: "10px",
        marginBottom: "0px",
        padding: "0px",
        minWidth: "30px",
        cursor: "pointer",
        color: "inherit",
    }))

    return (
        <Box>
            <ListItemStyled
                onClick={handleClick}
                sx={{ display: "flex", gap: "15px" }}
            >
                <ListIConStyled style={{ minWidth: "0px" }}>
                    {icon ? icon : ""}
                </ListIConStyled>
                {!customizer.isCollapse && (
                    <>
                        <ListItemText sx={{ my: 0 }}>
                            <Typography
                                fontSize={textFontSize}
                                sx={{ lineHeight: "1" }}
                                variant="caption"
                            >
                                {title}
                            </Typography>
                        </ListItemText>
                        {open ? <ExpandLess /> : <ExpandMore />}
                    </>
                )}
            </ListItemStyled>

            <Collapse
                in={open}
                timeout="auto"
                unmountOnExit
                sx={{ pl: isSidebarCollapsed ? 0 : 3 }}
            >
                <List component="div" disablePadding>
                    {children}
                </List>
            </Collapse>
        </Box>
    )
}

export { Submenu }
